import { select } from 'redux-saga/effects';
import { fetch } from '../../../_app/middleware/fetch';
import config from '../../../config';

const VALID_URL_REGEX =
  '^(http://www.|https://www.|http://|https://)?[a-z0-9]+([-.]{1}[a-z0-9]+)*.[a-z]{2,5}(:[0-9]{1,5})?(/.*)?$';

// ACTIONS

export const SET_FLYER_APPROVAL_GUIDELINES_URL =
  'SET_FLYER_APPROVAL_GUIDELINES_URL';

export const SET_STAFF_GROUP_FLYER_NOTIFICATION_PREFERENCE =
  'SET_STAFF_GROUP_FLYER_NOTIFICATION_PREFERENCE';

export const SET_FLYER_DISCLAIMER_INCLUSION_PREFERENCE =
  'SET_FLYER_DISCLAIMER_INCLUSION_PREFERENCE';

export const SET_FLYER_DISCLAIMER = 'SET_FLYER_DISCLAIMER';

export const SET_ORGANIZATION_DENIAL_CONTACT_INFO =
  'SET_ORGANIZATION_DENIAL_CONTACT_INFO';

export const SAVE_ORGANIZATION_SETTINGS = 'SAVE_ORGANIZATION_SETTINGS';

export const TOGGLE_ORGANIZATION_COMMUNICATION_DOWNLOADED =
  'TOGGLE_ORGANIZATION_COMMUNICATION_DOWNLOADED';

// ACTION CREATOR

export function setFlyerApprovalGuidelinesUrl(url) {
  return { type: SET_FLYER_APPROVAL_GUIDELINES_URL, payload: url };
}

export function setStaffGroupFlyerNotificationPreference(canSendFlyersToStaff) {
  return {
    type: SET_STAFF_GROUP_FLYER_NOTIFICATION_PREFERENCE,
    payload: canSendFlyersToStaff,
  };
}

export function setFlyerDisclaimerInclusionPreference(flyerDisclaimerRequired) {
  return {
    type: SET_FLYER_DISCLAIMER_INCLUSION_PREFERENCE,
    payload: flyerDisclaimerRequired,
  };
}

export function setFlyerDisclaimer(flyerDisclaimer) {
  return {
    type: SET_FLYER_DISCLAIMER,
    payload: flyerDisclaimer,
  };
}

export function setOrganizationDenialContactInformation(
  organizationDenialContactInformation
) {
  return {
    type: SET_ORGANIZATION_DENIAL_CONTACT_INFO,
    payload: organizationDenialContactInformation,
  };
}

export function saveOrganizationSettings() {
  return {
    type: SAVE_ORGANIZATION_SETTINGS,
  };
}

export function toggleOrganizationCommunicationDownloaded(boolean) {
  return {
    type: TOGGLE_ORGANIZATION_COMMUNICATION_DOWNLOADED,
    payload: boolean,
  };
}

// SAGAS

const getOrganizationSettings = state => state.organizationSettings;
const getRegistrationId = state => state.user.registrationId;
const getPostOrganizationParams = state => ({
  flyerGuidlinesUrl:
    state.organizationSetup.flyerApprovalGuidelinesUrl.length === 0
      ? undefined
      : state.organizationSetup.flyerApprovalGuidelinesUrl,
  canSendFlyersToStaffGroup: state.organizationSetup.canSendFlyersToStaff,
  flyerDisclaimerRequired: state.organizationSetup.flyerDisclaimerRequired,
  flyerDisclaimer:
    state.organizationSetup.flyerDisclaimer.length === 0
      ? undefined
      : state.organizationSetup.flyerDisclaimer,
  denialContactInformation:
    state.organizationSetup.organizationDenialContactInformation.length === 0
      ? undefined
      : state.organizationSetup.organizationDenialContactInformation,
});

export function* postToSaveOrganizationSettings() {
  const postParams = yield select(getPostOrganizationParams);
  const registrationId = yield select(getRegistrationId);

  const action = {
    data: postParams,
    method: 'post',
    url: `${
      config.REACT_APP_API_BASE_URL
    }/districts/onboarding/${registrationId}/save-organization-settings`,
  };

  const response = yield fetch(action);
}

// REDUCER
const initialState = {
  flyerApprovalGuidelinesUrl: '',
  canSendFlyersToStaff: false,
  flyerDisclaimerRequired: false,
  flyerDisclaimer: '',
  organizationDenialContactInformation: '',
  organizationCommunicationDownloaded: false,
};

export const organizationSetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FLYER_APPROVAL_GUIDELINES_URL:
      return {
        ...state,
        flyerApprovalGuidelinesUrl: action.payload,
        isValidUrl: isValidUrl(action.payload),
      };
    case SET_STAFF_GROUP_FLYER_NOTIFICATION_PREFERENCE:
      return {
        ...state,
        canSendFlyersToStaff: action.payload,
      };
    case SET_FLYER_DISCLAIMER_INCLUSION_PREFERENCE:
      return {
        ...state,
        flyerDisclaimerRequired: action.payload,
      };
    case SET_FLYER_DISCLAIMER:
      return {
        ...state,
        flyerDisclaimer: action.payload,
      };
    case SET_ORGANIZATION_DENIAL_CONTACT_INFO:
      return {
        ...state,
        organizationDenialContactInformation: action.payload,
      };
    case TOGGLE_ORGANIZATION_COMMUNICATION_DOWNLOADED:
      return {
        ...state,
        organizationCommunicationDownloaded: action.payload,
      };
    default:
      return state;
  }
};

// Helper functions
export const isValidUrl = url => RegExp(VALID_URL_REGEX).test(url);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/organization/setup-organization.duck.js